<template>
    <div class="text-center">
        <h1 class="h1 font-weight-bold d-none d-lg-block">{{ $t('Járat igénylés') }}</h1>

        <div class="demand-request__top mb-4">

            <div class="switcher mb-4" :class="'switcher--active-'+tab">
                <button type="button" class="switcher__button" :class="{'switcher__button--active': tab === 'bus'}" @click="tab = 'bus'">
                    <span class="switcher__icon"><inline-svg :src="require('@/assets/icons/bus.svg')" ></inline-svg></span>
                    <span class="switcher__text">{{$t('Járatválasztó')}}</span>
                </button>

                <button class="switcher__button" :class="{'switcher__button--active': tab === 'stop'}" @click="tab = 'stop'">
                    <span class="switcher__icon"><inline-svg :src="require('@/assets/icons/pin.svg')" ></inline-svg></span>
                    <span class="switcher__text">{{$t('Megállóválasztó')}}</span>
                </button>
            </div>
            <CsobajInfoBox/>
            <content-loader :width="470"
            :height="61"
            primaryColor="#ffffff"
            secondaryColor="#ecebeb"
            :speed="2" v-if="nearestStationLoading" class="mb-4 shadow-block p-0">
                <rect x="0" y="0" rx="6" ry="6" width="470" height="61" />
            </content-loader>

            <div class="shadow-block mb-4 cursor-pointer" v-if="!nearestStationLoading && nearestStation.id !== null" @click="$router.push({name: 'demand-request-process', params: {routeId: nearestStation.routeId}, query: {directionId: nearestStation.directionId}})">
                <div class="form-row align-items-center">
                    <div class="col-auto shadow-block__pin">
                        <inline-svg :src="require('@/assets/icons/pin-filled.svg')" ></inline-svg>
                    </div>
                    <div class="col text-left">
                        <div class="color-grey3 text-smaller text-ellipsis">{{$t('Hozzád legközelebbi megálló')}}</div>
                        <div class="text-biggest text-ellipsis">{{nearestStation.stopName}}</div>
                    </div>
                    <div class="col-auto text-right">
                        <RouteBadge
                            :route-id="nearestStation.routeId"
                            :route-name="nearestStation.routeName"
                            :route-color="nearestStation.routeColor"
                            :route-text-color="nearestStation.routeTextColor"
                            small
                        />
                        <div class="text-smaller color-grey3">{{nearestStation.distance | distance}}</div>
                    </div>
                </div>
            </div>
            <form @submit.prevent.stop="tab === 'stop'?getStops() : getRoutes()">
                <div class="form-row align-items-center">
                    <div class="col">
                        <div class="form-group m-0">
                            <label for="filterStop" class="d-none">{{$t('Adja meg a kívánt megálló címét')}}</label>
                            <label for="filterBus" class="d-none">{{$t('Adja meg a kívánt járat számát')}}</label>
                            <input
                                v-if="tab === 'stop'"
                                v-input-class
                                v-model="filterStop"
                                type="text"
                                id="filterStop"
                                class="input bg-white input--small pl-3"
                                :placeholder="$t('Adja meg a kívánt megálló címét')"
                            />
                            <input
                                v-else
                                v-input-class
                                v-model="filterBus"
                                type="text"
                                id="filterBus"
                                class="input bg-white input--small pl-3"
                                :placeholder="$t('Adja meg a kívánt járat számát')"
                            />
                        </div>
                    </div>
                    <div class="col-auto"><button type="submit" class="button button--small">{{$t('Keresés')}}</button></div>
                </div>
            </form>

        </div>

        <template v-if="(tab==='bus' && routesLoading) || (tab==='stop' && stopsLoading)">
                <content-loader
                    :width="730"
                    :height="694"
                    :speed="2"
                    primaryColor="#ffffff"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="6" ry="6" width="730" height="78" /> 
                    <rect x="0" y="88" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="176" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="264" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="352" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="440" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="528" rx="6" ry="6" width="730" height="78" />
                    <rect x="0" y="616" rx="6" ry="6" width="730" height="78" />
                </content-loader>
        </template>

        <ul class="routes routes--bus" v-if="tab==='bus' && !routesLoading">
            <router-link :to="{name: 'demand-request-process', params: {routeId: route.routeId}, query: {directionId: route.directionId}}" tag="li" class="routes__item text-left" v-for="(route, index) in routes" :key="index">
                    <div class="form-row align-items-center">
                        <div class="col-auto text-bigger">
                          <RouteBadge
                              :route-id="route.routeId"
                              :route-name="route.routeName"
                              :route-color="route.routeColor"
                              :route-text-color="route.routeTextColor"
                          />
                        </div>
                        <div class="col text-bigger">
                            <div>{{route.fromStopName}}</div>
                            <div>{{route.toStopName}}</div>
                        </div>
                        <div class="col-auto">
                            <img src="@/assets/icons/arrow-right.svg" alt="Mehet">
                        </div>
                    </div>
                </router-link>
        </ul>
        <div class="shadow-block text-center font-weight-bold" v-if="tab==='bus' && !routesLoading && !routes.length">
            {{$t('Jelenleg nincs megjeleníthető járat')}}
        </div>

        <ul class="routes routes--stop" v-if="tab==='stop' && !stopsLoading">
            <router-link v-waypoint="index === waypointIndex ? { active: true, callback: waypointCallback } : {active: false}" :to="{name: 'demand-request-process', params: {routeId: stop.routeId}, query: {directionId: stop.directionId.toString(), fromStop: stop.stopId}}" tag="li" class="routes__item text-left" v-for="(stop, index) in stops" :key="index">
                <div class="form-row align-items-center">
                    <div class="col-auto">
                        <div class="routes__pin-icon" @click.prevent.stop="openGoogleMaps(stop)"><inline-svg :src="require('@/assets/icons/pin-filled.svg')" ></inline-svg></div>
                    </div>
                    <div class="col text-bigger">
                        <div class="form-row align-items-center">
                            <div class="col-auto">{{stop.stopName}}</div>
                            <div class="col-auto"><inline-svg class="routes__direction-icon" :src="require('@/assets/icons/direction-right.svg')" ></inline-svg></div>
                            <div class="col-auto">{{stop.lastStopName}}</div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <img src="@/assets/icons/arrow-right.svg" alt="Mehet">
                    </div>
                    <div class="col-auto text-right">
                        <div v-if="stop.closestArrivalTime">{{stop.closestArrivalTime | arrivalTime}}</div>
                        <div>
                            <RouteBadge
                                :route-id="stop.routeId"
                                :route-name="stop.routeName"
                                :route-color="stop.routeColor"
                                :route-text-color="stop.routeTextColor"
                                small
                            />
                        </div>
                        <div class="text-smaller color-grey3" v-if="stop.distance">{{stop.distance | distance}}</div>
                    </div>
                </div>
            </router-link>
        </ul>
        <div class="shadow-block text-center font-weight-bold" v-if="tab==='stop' && !stopsLoading && !stops.length">
            {{$t('Jelenleg nincs megjeleníthető megálló')}}
        </div>


    </div>
</template>

<script>
import { findNearestStopUsingGET, getFilteredStopsUsingGET, getDemandDrivenRoutesUsingGET } from '@/api'
import {GtfsStop} from "@/models"
import CsobajInfoBox from '@/components/CsobajInfoBox.vue';
import RouteBadge from '@/components/RouteBadge.vue';
    export default {
        name: 'DemandRequest',
        components: {
            CsobajInfoBox,
            RouteBadge
        },
        data() {
            return {
                tab: 'bus',
                stopsPagingActive: true,
                stopsPagingLoading: false,
                stopsPage: 0,
                stopsSize: 20,
                nearestStationLoading: false,
                stopsLoading: false,
                routesLoading: false,
                filterBus: null,
                filterStop: null,
                userLat: null,
                userLong: null,
                nearestStation: new GtfsStop(),
                stops: [],
                routes: []
            }
        },
        computed: {
            waypointIndex: function() {
                let page = this.stopsPage=== 0? 1 : this.stopsPage;
                return (page * this.stopsSize) - 5;
            }
        },
        created() {
            navigator.geolocation.getCurrentPosition((position) => {
                this.userLat = position.coords.latitude;
                this.userLong = position.coords.longitude;
                this.nearestStationLoading = true;

                findNearestStopUsingGET({latitude: this.userLat, longitude: this.userLong}).then(response => {
                    this.$set(this, 'nearestStation', response.data);
                    this.nearestStationLoading = false;
                }).catch(err => {
                    this.nearestStationLoading = false;
                });

                this.getData();
            });
            this.getData();
                
        },
        watch: {
            tab: function(val) {
                switch(this.tab) {
                    case "bus":
                        if(!this.routes.length && !this.routesLoading)
                        this.getRoutes();
                        break;
                    case "stop":
                        if(!this.stops.length && !this.stopsLoading)
                        this.getStops();
                        break;
                }
            }
        },
        methods: {
            waypointCallback: function({ going }) {
                if(going === this.$waypointMap.GOING_IN) {
                    this.getStops(true);
                }
            },
            getData: function() {
                switch(this.tab) {
                    case "bus":
                        this.getRoutes();
                        break;
                    case "stop":
                        this.getStops();
                        break;
                }
            },
            getRoutes: function() {
                let params = {}
                if(this.filterBus)
                    params.name = this.filterBus;
                this.routesLoading = true;
                getDemandDrivenRoutesUsingGET(params).then((response) => {
                    this.routes = response.data;
                    this.routes.sort(function(a, b) { 
                        return parseInt(a.routeName) - parseInt(b.routeName);
                    });
                    this.routesLoading = false;
                }).catch(err => {
                    this.routesLoading = false;
                    this.$swal({
						title: this.$t("Járatválasztó"),
						text: this.$t("A járatok betöltése közben hiba történt. Hiba oka:") + " " + err.errorMessage,
						imageUrl: window.swalError,
					});
                });
            },
            getStops: function(paging) {
                if(typeof paging === "undefined") paging = false;
                let params = {}

                if(paging) {
                    if(!this.stopsPagingActive || this.stopsPagingLoading) return false;
                    this.stopsPage++;
                    this.stopPagingLoading = true;
                } else {
                    this.stopsLoading = true;
                    this.stopsPage = 0;
                    this.stopsPagingActive = true;
                }
                params.page = this.stopsPage;
                params.size = this.stopsSize;

                if(this.filterStop)
                    params.name = this.filterStop;

                if(this.userLat && this.userLong) {
                    params.latitude = this.userLat;
                    params.longitude = this.userLong;
                }
                
                getFilteredStopsUsingGET(params).then((response) => {
                    if(!paging)
                        this.stops = response.data.content;
                    else {
                        this.stops = this.stops.concat(response.data.content);
                        this.stopsPagingLoading = false;
                    }
                    if(response.data.last)
                        this.stopsPagingActive = false;
                    this.stopsLoading = false;
                }).catch(err => {
					this.stopsLoading = false;
                    this.$swal({
						title: this.$t("Megállóválasztó"),
						text: this.$t("A megállók betöltése közben hiba történt. Hiba oka:") + " " + err.errorMessage,
						imageUrl: window.swalError,
					});
                });
            },
            openGoogleMaps: function(stop) {
                let a = document.createElement('a');
                a.target = "_blank";
                a.href = `https://www.google.com/maps/search/?api=1&query=${stop.latitude},${stop.longitude}`;

                a.click();
                a.remove();
            }
        },
        filters: {
            distance: function(val) {
                let v = parseFloat(val);

                return v > 1 ? v.toFixed(0) + "km" : (v*1000).toFixed(0) + "m";
            }
        }
    }
</script>

<style lang="scss" src="@/assets/scss/demand-request.scss" scoped></style>